export default "__VITE_ASSET__6gtFWjjV__"